<template>
    <section class="select-fuel">
        <div class="configurator__container container">
            <StepBar step-name="Select your fuel type" :step="2" :steps="7" />

            <div class="configurator__flex-container">
                <div class="configurator__flex-left">
                    <Navigation :go-to-step="{ name: 'select-gearbox', params: { brand: brand, urlModel: urlModel }, query: { id: configuratorId } }" />

                    <ImageGallery />
                </div>

                <div class="configurator__flex-right">
                    <Card :title="model.model_title" description="Choose your fuel type:" :price="cheapestPrice">
                        <LoadingSpinner v-if="loading"></LoadingSpinner>
                        <RadioButton v-else v-model="selectedFuelType" id-key="id" value-key="value" price-key="price" :options="fuelTypes" :show-prices="true" />
                    </Card>

                    <div ref="continueButton" class="configurator__continue-btn-container">
                        <button class="btn btn--primary btn--min-width btn--full-width-xs" :class="{'btn--disabled': !fuelTypeChoice}" :disbled="!fuelTypeChoice" @click="nextStep">Continue</button>
                    </div>

                    <SaveConfiguration />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import EventObject from "../../modules/tracking/EventObject";
import { mapState } from "vuex";
import scrollToElement from "../modules/scrollToElement";

export default {
    props: {
        brand: {
            type: String,
            required: true,
        },
        urlModel: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
        };
    },
    methods: {
        nextStep() {
            if (!this.fuelTypeChoice) {
                return;
            }
            new EventObject("New Car - Configurator", "Next Step", "Clicked to Step 3 of 7: Select trim").dispatch();

            this.$router.push({
                name: "select-trim",
                params: { brand: this.brand, urlModel: this.urlModel },
                query: { id: this.configuratorId },
            });
        },
    },
    created() {
        this.$store.dispatch("getFuelTypes").then(() => {
            document.title = `${this.model.model_title} ${this.gearboxChoice} | Configure My New ${this.manufacturer} Car`;

            this.$store.commit("setSelectedVehiclePrice", this.cheapestPrice);

            if (this.fuelTypes.length == 1) {
                this.selectedFuelType = this.fuelTypes[0].id;
            }

            this.loading = false;
        });
    },
    computed: {
        ...mapState(["model", "fuelTypeChoice", "configuratorId", "availableFuelTypes", "gearboxChoice", "manufacturer", "selectedVehiclePrice"]),
        fuelTypes() {
            return this.availableFuelTypes.map((fuelType) => {
                return {
                    id: fuelType.fuel_type,
                    value: fuelType.fuel_type.replace("Petrol/PlugIn Elec Hybrid", "Plug-in Hybrid"),
                    price: fuelType.pricing_display_price - this.cheapestPrice,
                };
            });
        },

        selectedFuelType: {
            get: function () {
                return this.$store.state.fuelTypeChoice;
            },
            set: function (selectedFuelTypeId) {
                for (let index = 0; index < this.fuelTypes.length; index++) {
                    const option = this.fuelTypes[index];

                    if (option.id != selectedFuelTypeId) {
                        continue;
                    }

                    this.$store.commit("setFuelTypeChoice", option.id);
                    this.$store.commit("setSelectedVehiclePrice", option.price + this.cheapestPrice);
                    scrollToElement(this.$refs['continueButton']);
                    return;
                }
            },
        },

        cheapestPrice() {
            return Math.min(...this.availableFuelTypes.map((fuel) => fuel.pricing_display_price));
        },
    },
};
</script>